module.exports = __webpack_public_path__ + "static/media/image-1200.dc0385ae.jpg";